import React from 'react'
import {
  StyledContainer,
  StyledIcon,
  StyledInfos,
  StyledInfosBloc,
  StyledInfosContainer,
  StyledMapContainer,
  StyledMapMarkerIcon,
  StyledStaticMap,
} from './StaticLocation.styled'
import MarkerIcon from '../../images/icons/marker.svg'
import PhoneIcon from '../../images/icons/phone.svg'
import MailIcon from '../../images/icons/mail.svg'
import FaxIcon from '../../images/icons/fax.svg'

const StaticLocation = (props) => {
  const {
    locationInfosEmail,
    locationInfosCountry,
    locationInfosFax,
    locationInfosLocation,
    locationInfosPhone,
    locationInfosState,
    locationInfosStreet,
    locationGoogleMapsUrl,
  } = props

  const GOOGLE_MAP_LINK = `https://www.google.com/maps/search/?api=1&query=${locationInfosLocation.lat},${locationInfosLocation.lon}`

  return (
    <StyledContainer>
      <StyledInfosContainer>
        {locationInfosLocation.lat && (
          <StyledMapContainer
            href={locationGoogleMapsUrl || GOOGLE_MAP_LINK}
            target="_blank"
          >
            <StyledStaticMap
              alt="Constellium map"
              src={`https://maps.googleapis.com/maps/api/staticmap?key=${process.env.GATSBY_GOOGLE_MAP_STATIC_API_KEY}&center=${locationInfosLocation.lat},${locationInfosLocation.lon}&zoom=12&format=png&maptype=roadmap&style=element:geometry%7Ccolor:0xf5f5f5&style=element:labels.icon%7Cvisibility:off&style=element:labels.text.fill%7Ccolor:0x616161&style=element:labels.text.stroke%7Ccolor:0xf5f5f5&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:poi%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi.park%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&size=480x360`}
            />
            <StyledMapMarkerIcon />
          </StyledMapContainer>
        )}
      </StyledInfosContainer>
      <StyledInfosContainer>
        <StyledInfosBloc
          href={locationGoogleMapsUrl || GOOGLE_MAP_LINK}
          target="_blank"
        >
          <StyledIcon>
            <MarkerIcon />
          </StyledIcon>
          <StyledInfos>
            {locationInfosStreet?.locationInfosStreet && (
              <p>{locationInfosStreet.locationInfosStreet}</p>
            )}
            {locationInfosState && <p>{locationInfosState}</p>}
            {locationInfosCountry && <p>{locationInfosCountry}</p>}
          </StyledInfos>
        </StyledInfosBloc>
        {locationInfosPhone && (
          <StyledInfosBloc href={`tel:${locationInfosPhone}`} target="_blank">
            <StyledIcon>
              <PhoneIcon />
            </StyledIcon>
            <StyledInfos>{locationInfosPhone}</StyledInfos>
          </StyledInfosBloc>
        )}
        {locationInfosEmail && (
          <StyledInfosBloc
            href={`mailto:${locationInfosEmail}`}
            target="_blank"
          >
            <StyledIcon>
              <MailIcon />
            </StyledIcon>
            <StyledInfos>{locationInfosEmail}</StyledInfos>
          </StyledInfosBloc>
        )}
        {locationInfosFax && (
          <StyledInfosBloc>
            <StyledIcon>
              <FaxIcon />
            </StyledIcon>
            <StyledInfos>{locationInfosFax}</StyledInfos>
          </StyledInfosBloc>
        )}
      </StyledInfosContainer>
    </StyledContainer>
  )
}

export default StaticLocation
